var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 0H5.625C4.59375 0 3.75 0.84375 3.75 1.875V18.125C3.75 19.1562 4.59375 20 5.625 20H14.375C15.4062 20 16.25 19.1562 16.25 18.125V1.875C16.25 0.84375 15.4062 0 14.375 0ZM7.5 0.9375H12.5V1.5625H7.5V0.9375ZM10 18.75C9.66848 18.75 9.35054 18.6183 9.11612 18.3839C8.8817 18.1495 8.75 17.8315 8.75 17.5C8.75 17.1685 8.8817 16.8505 9.11612 16.6161C9.35054 16.3817 9.66848 16.25 10 16.25C10.3315 16.25 10.6495 16.3817 10.8839 16.6161C11.1183 16.8505 11.25 17.1685 11.25 17.5C11.25 17.8315 11.1183 18.1495 10.8839 18.3839C10.6495 18.6183 10.3315 18.75 10 18.75ZM15 15H5V2.5H15V15Z",
    fill: "#3AB54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon-mobile.0c36150fd3d0796b217d868e3a21b572.svg";
export { ForwardRef as ReactComponent };